<template>
  <div id="FactHealthPlan" class="section">
    <div class="columns is-multiline is-mobile">
      <!-- TOTAL INCOME INFO. -->
      <div class="column is-12">
        <p class="title is-4 has-text-left">ข้อมูลเบื้องต้น</p>
        <div class="columns has-text-left is-multiline">
          <!-- 0 -->
          <div class="column is-12">
            <div class="columns is-multiline is-align-end">
              <div class="column is-4-desktop is-6-tablet is-12-mobile">
                <b-field label="โรงพยาบาล">
                  <b-input
                    type="text"
                    custom-class="prompt-font"
                    v-model="hospital_name"
                  />
                </b-field>
              </div>
              <div class="column is-4-desktop is-6-tablet is-12-mobile">
                <b-field label="โรคที่กังวล">
                  <b-input
                    type="text"
                    custom-class="prompt-font"
                    v-model="concern_disease"
                  />
                </b-field>
              </div>
              <div class="column is-2-desktop is-6-tablet is-12-mobile">
                <b-field label="ค่าห้อง / คืน">
                  <b-input
                    type="number"
                    min="0"
                    custom-class="prompt-font"
                    placeholder="ประมาณการ"
                    v-model="avg_room_amount"
                  />
                </b-field>
              </div>

              <div class="column is-2-desktop is-6-tablet is-12-mobile">
                <b-field label="ค่าใช้จ่ายโรคร้ายแรง">
                  <b-input
                    type="number"
                    min="0"
                    custom-class="prompt-font"
                    placeholder="ประมาณการ"
                    v-model="total_expense"
                  />
                </b-field>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- TOTAL INSURANCE INFO. -->
      <div class="column is-12">
        <p class="title is-4 has-text-left">รายละเอียดประกันสุขภาพ</p>
        <div class="columns has-text-left is-multiline">
          <!-- 1 -->
          <div class="column is-6-desktop is-12-tablet is-12-mobile">
            <b-field label="ค่าห้อง ค่าอาหาร ค่าบริการ"> </b-field>
            <div class="columns is-multiline is-align-end">
              <div class="column is-4">
                <b-field label="สิทธิ์ที่มีอยู่">
                  <b-input
                    type="number"
                    min="0"
                    custom-class="prompt-font"
                    placeholder="สิทธิ์ที่มีอยู่"
                    v-model="room_value"
                  />
                </b-field>
              </div>
              <div class="column is-4">
                <b-field label="สวัสดิการที่แนะนำ">
                  <b-input
                    type="number"
                    min="0"
                    custom-class="prompt-font"
                    placeholder="สวัสดิการที่แนะนำ"
                    v-model="room_max"
                  />
                </b-field>
              </div>
              <div class="column is-4">
                <b-radio v-model="main_topic" native-value="room">
                  <p class="subtitle is-7">แสดงหน้าสรุป</p>
                </b-radio>
              </div>
            </div>
          </div>
          <!-- 2 -->
          <div class="column is-6-desktop is-12-tablet is-12-mobile">
            <b-field label="ค่ารักษาเหมาจ่าย"> </b-field>
            <div class="columns is-multiline is-align-end">
              <div class="column is-4">
                <b-field label="สิทธิ์ที่มีอยู่">
                  <b-input
                    type="number"
                    min="0"
                    custom-class="prompt-font"
                    placeholder="สิทธิ์ที่มีอยู่"
                    v-model="flatfee_value"
                  />
                </b-field>
              </div>
              <div class="column is-4">
                <b-field label="สวัสดิการที่แนะนำ">
                  <b-input
                    type="number"
                    min="0"
                    custom-class="prompt-font"
                    placeholder="สวัสดิการที่แนะนำ"
                    v-model="flatfee_max"
                  />
                </b-field>
              </div>
              <div class="column is-4">
                <b-radio v-model="main_topic" native-value="flat_fee">
                  <p class="subtitle is-7">แสดงหน้าสรุป</p>
                </b-radio>
              </div>
            </div>
          </div>
          <!-- 3 -->
          <div class="column is-6-desktop is-12-tablet is-12-mobile">
            <b-field label="ค่ารักษาผู้ป่วยนอก OPD"> </b-field>
            <div class="columns is-multiline is-align-end">
              <div class="column is-4">
                <b-field label="สิทธิ์ที่มีอยู่">
                  <b-input
                    type="number"
                    min="0"
                    custom-class="prompt-font"
                    placeholder="สิทธิ์ที่มีอยู่"
                    v-model="opd_value"
                  />
                </b-field>
              </div>
              <div class="column is-4">
                <b-field label="สวัสดิการที่แนะนำ">
                  <b-input
                    type="number"
                    min="0"
                    custom-class="prompt-font"
                    placeholder="สวัสดิการที่แนะนำ"
                    v-model="opd_max"
                  />
                </b-field>
              </div>
              <div class="column is-4">
                <b-radio v-model="main_topic" native-value="opd">
                  <p class="subtitle is-7">แสดงหน้าสรุป</p>
                </b-radio>
              </div>
            </div>
          </div>
          <!-- 4 -->
          <div class="column is-6-desktop is-12-tablet is-12-mobile">
            <b-field label="ค่าชดเชย"> </b-field>
            <div class="columns is-multiline is-align-end">
              <div class="column is-4">
                <b-field label="สิทธิ์ที่มีอยู่">
                  <b-input
                    type="number"
                    min="0"
                    custom-class="prompt-font"
                    placeholder="สิทธิ์ที่มีอยู่"
                    v-model="compen_value"
                  />
                </b-field>
              </div>
              <div class="column is-4">
                <b-field label="สวัสดิการที่แนะนำ">
                  <b-input
                    type="number"
                    min="0"
                    custom-class="prompt-font"
                    placeholder="สวัสดิการที่แนะนำ"
                    v-model="compen_max"
                  />
                </b-field>
              </div>
              <div class="column is-4">
                <b-radio v-model="main_topic" native-value="compensate">
                  <p class="subtitle is-7">แสดงหน้าสรุป</p>
                </b-radio>
              </div>
            </div>
          </div>
          <!-- 5 -->
          <div class="column is-6-desktop is-12-tablet is-12-mobile">
            <b-field label="โรคร้ายแรง"> </b-field>
            <div class="columns is-multiline is-align-end">
              <div class="column is-4">
                <b-field label="สิทธิ์ที่มีอยู่">
                  <b-input
                    type="number"
                    min="0"
                    custom-class="prompt-font"
                    placeholder="สิทธิ์ที่มีอยู่"
                    v-model="illness_value"
                  />
                </b-field>
              </div>
              <div class="column is-4">
                <b-field label="สวัสดิการที่แนะนำ">
                  <b-input
                    type="number"
                    min="0"
                    custom-class="prompt-font"
                    placeholder="สวัสดิการที่แนะนำ"
                    v-model="illness_max"
                  />
                </b-field>
              </div>
              <div class="column is-4">
                <b-radio v-model="main_topic" native-value="serious_illness">
                  <p class="subtitle is-7">แสดงหน้าสรุป</p>
                </b-radio>
              </div>
            </div>
          </div>
          <!-- 6 -->
          <div class="column is-6-desktop is-12-tablet is-12-mobile">
            <b-field label="อุบัติเหตุ"> </b-field>
            <div class="columns is-multiline is-align-end">
              <div class="column is-4">
                <b-field label="สิทธิ์ที่มีอยู่">
                  <b-input
                    type="number"
                    min="0"
                    custom-class="prompt-font"
                    placeholder="สิทธิ์ที่มีอยู่"
                    v-model="accident_value"
                  />
                </b-field>
              </div>
              <div class="column is-4">
                <b-field label="สวัสดิการที่แนะนำ">
                  <b-input
                    type="number"
                    min="0"
                    custom-class="prompt-font"
                    placeholder="สวัสดิการที่แนะนำ"
                    v-model="accident_max"
                  />
                </b-field>
              </div>
              <div class="column is-4">
                <b-radio v-model="main_topic" native-value="accident">
                  <p class="subtitle is-7">แสดงหน้าสรุป</p>
                </b-radio>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="btn-mt">
      <div class="columns is-centered">
        <div class="column is-2-desktop is-4-tablet is-12-mobile">
          <b-button
            outlined
            expanded
            class="prompt-font"
            @click.prevent="backwardStep()"
            >ย้อนกลับ
          </b-button>
        </div>
        <div v-if="edited" class="column is-2-desktop is-4-tablet is-12-mobile">
          <b-button
            outlined
            expanded
            type="is-primary"
            class="prompt-font"
            @click.prevent="updateFactInfoState()"
          >
            บันทึก
          </b-button>
        </div>
        <div class="column is-2-desktop is-4-tablet is-12-mobile">
          <b-button
            expanded
            type="is-primary"
            class="prompt-font"
            @click.prevent="saveFactInfoState"
          >
            ต่อไป
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "FactHealthPlan",
  props: ["edited"],
  computed: {
    ...mapState(["factsheet_insurance"])
  },
  data() {
    return {
      main_topic: "room",
      hospital_name: null,
      concern_disease: null,
      avg_room_amount: null,
      total_expense: null,
      room_max: null,
      room_value: null,
      flatfee_max: null,
      flatfee_value: null,
      opd_max: null,
      opd_value: null,
      compen_max: null,
      compen_value: null,
      illness_max: null,
      illness_value: null,
      accident_max: null,
      accident_value: null
    };
  },
  methods: {
    ...mapMutations({
      setFactSheetInsurance: "SET_FACTSHEET_INSURANCE"
    }),
    /* For Display Existing Information */
    setUpHealthInfo(health_insurance_info) {
      this.hospital_name = health_insurance_info.hospital_name;
      this.concern_disease = health_insurance_info.concern_disease;
      this.avg_room_amount = health_insurance_info.avg_room_amt;
      this.total_expense = health_insurance_info.expense;
    },
    setUpHealthDetailInfo(health_detail_info) {
      this.room_max = health_detail_info.room.max;
      this.room_value = health_detail_info.room.value;

      this.flatfee_max = health_detail_info.flat_fee.max;
      this.flatfee_value = health_detail_info.flat_fee.value;

      this.opd_max = health_detail_info.opd.max;
      this.opd_value = health_detail_info.opd.value;

      this.compen_max = health_detail_info.compensate.max;
      this.compen_value = health_detail_info.compensate.value;

      this.illness_max = health_detail_info.serious_illness.max;
      this.illness_value = health_detail_info.serious_illness.value;

      this.accident_max = health_detail_info.accident.max;
      this.accident_value = health_detail_info.accident.value;
    },
    /* Button Action Handler */
    saveFactInfoState: function() {
      if (!this.edited) {
        let plan_insurance = this.createFactInfoInsuranceObject();
        this.setFactSheetInsurance(plan_insurance);
      }
      this.$emit("form_completed");
    },
    updateFactInfoState: function() {
      if (this.edited) {
        let plan_insurance = this.createFactInfoInsuranceObject();
        this.setFactSheetInsurance(plan_insurance);
        this.$emit("existing_sheet_updated");
      }
    },
    backwardStep: function() {
      this.$emit("back");
    },
    /* API & PARAMS*/
    createFactInfoInsuranceObject: function() {
      const plan_insurance = {
        hospital_name: this.hospital_name,
        avg_room_amt: +this.avg_room_amount,
        concern_disease: this.concern_disease,
        expense: +this.total_expense,
        detail: {
          room: {
            min: 0,
            max: +this.room_max,
            value: +this.room_value
          },
          flat_fee: {
            min: 0,
            max: +this.flatfee_max,
            value: +this.flatfee_value
          },
          opd: {
            min: 0,
            max: +this.opd_max,
            value: +this.opd_value
          },
          compensate: {
            min: 0,
            max: +this.compen_max,
            value: +this.compen_value
          },
          serious_illness: {
            min: 0,
            max: +this.illness_max,
            value: +this.illness_value
          },
          accident: {
            min: 0,
            max: +this.accident_max,
            value: +this.accident_value
          }
        }
      };

      const entries = Object.entries(plan_insurance.detail);
      for (const [key, value] of entries) {
        if (key === this.main_topic) {
          value["selected"] = true;
        }
      }
      return plan_insurance;
    }
  },
  beforeMount() {
    if (this.edited) {
      this.setUpHealthInfo(this.factsheet_insurance);
      this.setUpHealthDetailInfo(this.factsheet_insurance.detail);
    }
  }
};
</script>

<style scoped>
.is-align-end {
  align-items: flex-end;
}
</style>
